<div class="scroll-to-top" [ngClass]="{'show-scrollTop': windowScrolled}">
    <!-- <button (click)="scrollToTop()">
        <i class="fa fa-chevron-up"></i>
    </button> -->
    <button mat-mini-fab color="primary" aria-label="Move to top" (click)="scrollToTop()">
        <mat-icon>keyboard_double_arrow_up</mat-icon>
      </button>
</div>